export default class ApiUtil {
    //static URL_IP = 'http://127.0.0.1:5000';
    static URL_ROOT = '/api/v1';

    static API_STAFF_UPDATE = ApiUtil.URL_ROOT + '/updateStaff';
    
}
